import { useTranslation } from '@crehana/i18n';

import { SocialButtonsV2, Title } from '../components';
import type { AuthInnerFormProps, OnChangeForm } from '../types';
import { getNextUrl, redirectWithQueryParams } from '../utils';
import SignupForm from './SignupForm';

type SignUpProps = {
  referFriendId?: number;
  onCustomSuccess: AuthInnerFormProps['onCustomSuccess'];
  /**
   * Pass the page, section or component where this component is used.
   * This prop is used to send extra data to the Amplitude
   */
  isRenderedIn?: string;
  emailDefault?: string;
  isDark?: boolean;
  onChangeForm?: OnChangeForm;
};

const SignUp: React.FC<React.PropsWithChildren<SignUpProps>> = ({
  referFriendId,
  onCustomSuccess,
  isRenderedIn,
  emailDefault,
  isDark,
  onChangeForm,
}) => {
  const { t } = useTranslation();
  const nextUrl = getNextUrl();
  const onSuccess = ({
    redirect,
    isNewUser,
  }: {
    redirect?: string | null;
    isNewUser?: boolean | null;
  }) => {
    if (isNewUser) {
      window.location.href = '/registro-extra/';
      return;
    }

    window.location.href = redirect || '/home/';
  };

  const toggleView = () => {
    if (onChangeForm) {
      // the arg that onChangeForm recevies is the current view
      onChangeForm('login');
    } else {
      redirectWithQueryParams('/entrar/');
    }
  };

  return (
    <div data-testid="signup-container">
      <div className="text-center mb-32">
        <Title formView="register" isDark={isDark} />
      </div>
      <div
        style={{
          maxWidth: 320,
          margin: 'auto',
        }}
      >
        <SocialButtonsV2
          nextUrl={nextUrl}
          referFriendId={referFriendId}
          getNextUrl={getNextUrl}
          onSuccess={onSuccess}
          isDark={isDark}
          formView="register"
        />
        <div className="mb-32">
          <SignupForm
            referFriendId={referFriendId}
            onCustomSuccess={onCustomSuccess}
            isRenderedIn={isRenderedIn}
            emailDefault={emailDefault}
            isDark={isDark}
            onChangeForm={onChangeForm}
          />
        </div>
        <div className="flex justify-center items-center mt-32">
          <span
            className={`font-body4 block mr-12 ${isDark ? 'text-white' : ''}`}
          >
            {t('DO_YOU_HAVE_A_ACCOUNT', {
              defaultValue: '¿Ya tienes una cuenta?',
            })}
          </span>{' '}
          <button type="button" onClick={toggleView}>
            <span className="text-green-main font-body4 tw-font-semibold">
              {t('SIGN_IN', { defaultValue: 'Inicia sesión' })}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
